import React, { useMemo, useContext } from 'react';
import { TeamContext } from 'contexts';
import { Link } from 'react-router-dom';
import { ListingLayoutCard, Loading } from '../components';
import { useListings } from '../hooks';
import ListingsSection from '../Section/ListingsSection';

const TeamListingsCard = () => {
  const { targetTeamId } = useContext(TeamContext);

  const {
    availability,
    availabilityOptions,
    filteredListingsByAvailability: listings,
    onStatusChange,
    onAvailabilityChange,
    isLoading,
    searchValue,
    setSearchValue,
  } = useListings({ searchType: 'team', targetTeamId });

  const actions = useMemo(() => listings.length > 0
      ? {
          actions: [
            <Link key="view-all-link" to="/listing/list/team/0">
              View All
            </Link>,
          ],
        }
      : {}, [listings]);

  return (
    <ListingLayoutCard
      search={{ searchValue, onSearchValueChange: setSearchValue }}
      titleLink={{
        title: <span data-cy="view-all-team-listings">Team Listings</span>,
        linkPath: '/listing/list/team/0',
      }}
      onStatusChange={onStatusChange}
      onAvailabilityChange={onAvailabilityChange}
      availabilityOptions={availabilityOptions}
      availability={availability}
      data-cy="dashboard-team-listings-card"
      {...actions}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <ListingsSection listings={listings} isTeamListing />
      )}
    </ListingLayoutCard>
  );
};

export default TeamListingsCard;
